import { useLanguages } from "@/hooks/use-languages";
import { cn } from "@/lib/utils";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Check, Ellipsis, Search } from "lucide-react";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "../ui/command";
import { PopoverClose } from "@radix-ui/react-popover";

export const EntityInstanceLanguageSelect: React.FC = ({}) => {
  const { languages, selectedLanguage, setSelectedLanguage } = useLanguages();
  return (
    <div className="flex w-fit items-center gap-2 rounded-md bg-gray-100 p-1">
      {languages.slice(0, 10).map((l) => (
        <div
          key={l.id}
          className={cn(
            "flex h-full cursor-pointer items-center rounded-[2px] px-3 py-0.5 text-sm font-medium text-muted-foreground",
            {
              "bg-white text-secondary shadow-sm": l.locale === selectedLanguage?.locale,
            },
          )}
          onClick={() => {
            setSelectedLanguage(l);
          }}
        >
          {l.locale?.toLocaleUpperCase()}
        </div>
      ))}
      {languages.length > 10 && (
        <Popover>
          <PopoverTrigger>
            <div className="flex-grow px-3 py-0.5 text-end">
              <Ellipsis />
              <Search className="ml-auto hidden" />
            </div>
          </PopoverTrigger>
          <PopoverContent className="p-0">
            <Command>
              <CommandInput />
              <CommandList>
                <CommandEmpty>No results.</CommandEmpty>
                <CommandGroup>
                  {languages.map((x, idx) => {
                    const name = `${x.name} (${x.locale?.toLocaleUpperCase()})`;
                    return (
                      <CommandItem value={name} key={idx} onSelect={() => setSelectedLanguage(x)}>
                        <PopoverClose className="flex items-center gap-2">
                          <Check
                            className={x.locale !== selectedLanguage?.locale ? "opacity-0" : ""}
                          />
                          {name}
                        </PopoverClose>
                      </CommandItem>
                    );
                  })}
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>
      )}
    </div>
  );
};
